import HTTP from "@/http";

const state = {
    isAuthenticated: false,
    user: {},
    notifications: [],
};

const getters = {
    // notifications: state => state.user.notifications
};


const actions = {
    getUserPlaylists(context) {
        return new Promise((resolve, reject) => {
        HTTP.get(`playlists`, {params: {user_id: "me", all: true, with: ["audios"]}})
            .then(response => {
                context.commit("SET_USER_PLAYLISTS", response.data);
                resolve(response);
            })
            .catch(response => {
                // @TODO: error
                reject(error);
            });
        });
    },
    getLikes(context) {
        HTTP.get(`audios`, {params: {liked_by: "me", all: true}})
            .then(response => {
                context.commit("SET_LIKES", response.data);
            })
            .catch(response => {
                // @TODO: error
            });
    },
};


const mutations = {

    SET_LIKES(state, audios) {
        state.user.likes = audios;
    },
    SET_IS_AUTHENTICATED(state, isAuthenticated) {
        state.isAuthenticated = isAuthenticated;
    },
    SET_USER(state, user) {
        state.user = user;
    },
    SET_USER_PLAYLISTS(state, playlists) {
        state.user.playlists = playlists;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js